import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M11.333 1.333v7.334m3.334-2.134V3.467c0-.747 0-1.12-.146-1.406a1.33 1.33 0 0 0-.582-.582c-.286-.146-.659-.146-1.406-.146H5.412c-.974 0-1.462 0-1.855.179a2 2 0 0 0-.85.728c-.236.362-.31.844-.458 1.807L1.9 6.313c-.195 1.27-.293 1.906-.104 2.4a2 2 0 0 0 .88 1.026c.46.26 1.102.26 2.387.26H5.6c.373 0 .56 0 .703.074a.67.67 0 0 1 .291.29c.073.144.073.33.073.704v1.956c0 .908.736 1.644 1.644 1.644a.55.55 0 0 0 .5-.326l2.24-5.041c.103-.23.154-.344.234-.428a.7.7 0 0 1 .256-.166c.11-.04.235-.04.486-.04h.506c.747 0 1.12 0 1.406-.145.25-.128.454-.332.582-.582.146-.286.146-.659.146-1.406"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }